import React from 'react';
import './TopBar.css';

const TopBar = () => {
  return React.createElement(
    'div',
    { className: 'topbar' },
    React.createElement(
      'div',
      { className: 'container topbar-inner' },
      React.createElement(
        'div',
        { className: 'topbar-left' },
        React.createElement(
          'span',
          null,
          React.createElement('i', { className: 'fas fa-envelope' }),
          ' support@infonaukri.com'
        )
      ),
      React.createElement(
        'div',
        { className: 'topbar-right' },
        React.createElement('a', { href: '#', 'aria-label': 'Facebook', className: 'social-link' }, 
          React.createElement('i', { className: 'fab fa-facebook-f' })
        ),
        React.createElement('a', { href: '#', 'aria-label': 'Twitter', className: 'social-link' }, 
          React.createElement('i', { className: 'fab fa-twitter' })
        ),
        React.createElement('a', { href: '#', 'aria-label': 'Google Plus', className: 'social-link' }, 
          React.createElement('i', { className: 'fab fa-google-plus-g' })
        ),
        React.createElement('a', { href: '#', 'aria-label': 'Pinterest', className: 'social-link' }, 
          React.createElement('i', { className: 'fab fa-pinterest-p' })
        ),
        React.createElement('a', { href: '#', 'aria-label': 'Vimeo', className: 'social-link' }, 
          React.createElement('i', { className: 'fab fa-vimeo-v' })
        ),
        React.createElement('a', { href: '#', 'aria-label': 'LinkedIn', className: 'social-link' }, 
          React.createElement('i', { className: 'fab fa-linkedin-in' })
        ),
        React.createElement('a', { href: '#', 'aria-label': 'Dribbble', className: 'social-link' }, 
          React.createElement('i', { className: 'fab fa-dribbble' })
        ),
        React.createElement('a', { href: '#', 'aria-label': 'YouTube', className: 'social-link' }, 
          React.createElement('i', { className: 'fab fa-youtube' })
        ),
        React.createElement('a', { href: '#', 'aria-label': 'RSS', className: 'social-link' }, 
          React.createElement('i', { className: 'fas fa-rss' })
        )
      )
    )
  );
};

export default TopBar;